var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5463 3.07395C16.2832 2.47242 15.9038 1.92731 15.4295 1.46915C14.9547 1.00962 14.395 0.644437 13.7807 0.393462C13.1437 0.132183 12.4606 -0.001554 11.7708 1.36231e-05C10.8032 1.36231e-05 9.85907 0.261667 9.03863 0.7559C8.84235 0.874129 8.65588 1.00399 8.47923 1.14547C8.30258 1.00399 8.11612 0.874129 7.91984 0.7559C7.0994 0.261667 6.15529 1.36231e-05 5.18764 1.36231e-05C4.49085 1.36231e-05 3.81565 0.131809 3.17775 0.393462C2.56143 0.645424 2.00597 1.00786 1.52901 1.46915C1.05401 1.92679 0.674566 2.47203 0.412185 3.07395C0.139358 3.69998 0 4.36477 0 5.04895C0 5.69436 0.133469 6.3669 0.398445 7.05108C0.62024 7.62284 0.938211 8.21592 1.34451 8.81481C1.9883 9.76258 2.87352 10.751 3.97268 11.7531C5.79414 13.4141 7.59794 14.5615 7.67449 14.608L8.13967 14.9026C8.34576 15.0325 8.61074 15.0325 8.81683 14.9026L9.28201 14.608C9.35856 14.5596 11.1604 13.4141 12.9838 11.7531C14.083 10.751 14.9682 9.76258 15.612 8.81481C16.0183 8.21592 16.3382 7.62284 16.5581 7.05108C16.823 6.3669 16.9565 5.69436 16.9565 5.04895C16.9585 4.36477 16.8191 3.69998 16.5463 3.07395Z",
    fill: "#D91D1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedFavorite);
export default __webpack_public_path__ + "static/media/redFavorite.4e07626abdaea16c900d9573fa1f0e74.svg";
export { ForwardRef as ReactComponent };